import { API_BASE } from '../config';
import { getPostLoginPath } from './postLoginRedirect';

export function navigateAfterMemberLogin(
  navigate,
  { needsProfileCompletion, needsMemberOnboarding, roles, from, authKind = 'member' }
) {
  if (needsProfileCompletion) {
    navigate('/login/complete-profile', { replace: true });
    return;
  }
  if (needsMemberOnboarding) {
    navigate('/login/onboarding-family', { replace: true });
    return;
  }
  navigate(getPostLoginPath(roles, from, authKind), { replace: true });
}

export async function fetchMemberDashboardSession(token) {
  if (!token) return { ok: false, status: 0, data: {} };
  try {
    const res = await fetch(`${API_BASE}/api/dashboard`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json().catch(() => ({}));
    const ok = res.ok && data.success;
    return { ok, status: res.status, data };
  } catch {
    return { ok: false, status: 0, data: {} };
  }
}

export async function fetchMemberDashboard(token) {
  const result = await fetchMemberDashboardSession(token);
  if (result.ok) return result.data;
  return null;
}

export async function markMemberOnboardingComplete(token) {
  if (!token) return { ok: false, error: 'Not signed in.' };
  try {
    const res = await fetch(`${API_BASE}/api/member/onboarding-complete`, {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      return {
        ok: false,
        error: data.error || 'Could not save progress. Please try again.',
      };
    }
    return { ok: true, user: data.user };
  } catch {
    return { ok: false, error: 'Server error. Please try again.' };
  }
}
